module.exports = __webpack_public_path__ + "img/pop_lan@2x.54a49aa3.png";